import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import bannerUrl from "../images/community-banner.webp";
import { BANNER_HEIGHT } from "../../layout/pageWidth";

/**
 * Banner hero: a wide scenic picture (one 220 KB webp, not the old 475 KB JPEG
 * that was the LCP element) behind the headline, with a soft
 * dark wash so the white words read on any part of it. The old hero's four
 * stat cards of fabricated metrics (hardcoded "+12%" badges and a
 * "destinations" figure derived as postCount * 2 + 15) stay gone.
 */
const CommunityHero = () => (
  <section className={`relative flex min-h-[360px] items-center overflow-hidden bg-gray-900 ${BANNER_HEIGHT}`}>
    <img
      src={bannerUrl}
      alt=""
      width={2172}
      height={724}
      fetchPriority="high"
      className="absolute inset-0 h-full w-full object-cover object-center"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45" aria-hidden="true" />

    {/* Way back to the traveller's own trips, pinned to the top-left corner. The
        global navbar links onward (Community, Packages, Blogs) but never back to
        the dashboard. The page reserves pt-16/lg:pt-20 for that fixed navbar, so
        this clears it without an offset of its own. */}
    <Link
      to="/dashboard"
      className="absolute left-4 top-4 z-20 inline-flex items-center gap-2 rounded-lg px-3 py-2 text-[13px] font-medium text-white/90 transition-colors hover:bg-white/15 hover:text-white sm:left-6 lg:left-8"
    >
      <ArrowLeft size={15} /> Dashboard
    </Link>

    <div className="relative z-10 mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 pt-16 pb-14 sm:pt-20 sm:pb-16 text-center">
      <h1 className="mx-auto max-w-3xl text-3xl font-bold leading-tight tracking-tight text-white drop-shadow-md sm:text-4xl lg:text-5xl">
        Real trips, planned by real travellers
      </h1>
      <p className="mx-auto mt-4 max-w-2xl text-base text-white/90 drop-shadow sm:text-lg">
        Browse itineraries the community has actually travelled — then copy any
        of them and make it your own.
      </p>
    </div>
  </section>
);

export default CommunityHero;
